class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.isMobile = window.matchMedia("(max-width: 749px)").matches;

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.apply = this.querySelector(".filters__apply");
    this.debouncedOnSubmit = debounce((event) => this.onSubmitHandler(event), 500);
    this.apply.addEventListener("click", this.debouncedOnSubmit.bind(this));

    if (!this.isMobile) {
      let facetForm = this.querySelector('#FacetFiltersForm');
      if (facetForm) {
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
      }
    }

    this.addToggleGridListener();
    this.addFakeSelectListener();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;

      if (searchParams === FacetFiltersForm.searchParamsPrev) return;

      FacetFiltersForm.renderPage(searchParams, null, false);
    };

    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;

    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {html, url}];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderPagination(html);
        FacetFiltersForm.renderSort(html);

        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;

    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderPagination(html);
    FacetFiltersForm.renderSort(html);
  }

  static renderProductGridContainer(html) {
    const columns = document.querySelector(".product-grid").classList.contains("grid--2-col");
    const gridContainer = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');

    if (columns) {
      const grid = gridContainer.querySelector(".product-grid");

      grid.classList.add("grid--2-col");
    }

    document.getElementById('ProductGridContainer').innerHTML = gridContainer.innerHTML;

    FacetFiltersForm.applyGridView();
  }

  static setGridView(singleColumn) {
    FacetFiltersForm.singleColumn = singleColumn;
    FacetFiltersForm.applyGridView();
  }

  // The <ul> carrying the one-column class lives inside #ProductGridContainer and is
  // replaced wholesale on every render above, while the toolbar icons sit outside it
  // and survive. Both are written from this one flag so they cannot disagree.
  static applyGridView() {
    const grid = document.querySelector(".js-product-grid");
    const iconSquare = document.querySelector(".filters__icons .icon--square");
    const iconGrid = document.querySelector(".filters__icons .icon--grid");
    const singleColumn = FacetFiltersForm.singleColumn === true;

    if (grid) grid.classList.toggle("product-grid__list--1-col", singleColumn);
    if (iconSquare) iconSquare.classList.toggle("icon--active", singleColumn);
    if (iconGrid) iconGrid.classList.toggle("icon--active", !singleColumn);
  }

  static renderProductCount(html) {
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (container) {
      const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
      container.innerHTML = count;
      container.classList.remove('loading');

      if (containerDesktop) {
        containerDesktop.innerHTML = count;
        containerDesktop.classList.remove('loading');
      }
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter'
    );

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;

      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };

    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const facet = element.querySelector(".filters__list");
      const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"] .filters__list`);

      if (target && facet) target.innerHTML = facet.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.filters__refinements'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);

      if (!activeFacetsElement) return;

      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({searchParams}, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static renderPagination(html) {
    const pagination = new DOMParser().parseFromString(html, 'text/html').querySelector('.js-pagination');

    if (pagination) document.querySelector('.js-pagination').replaceWith(pagination);
  }

  static renderSort(html) {
    const content = new DOMParser().parseFromString(html, 'text/html');
    const selectLabel = content.querySelector(".filters__label strong");
    const oldLabel = document.querySelector(".filters__label strong");
    const selectDesktop = content.querySelectorAll('.select .select__dropdown .select__item');
    const oldDesktop = Array.from(document.querySelectorAll('.select .select__dropdown .select__item'));

    FacetFiltersForm.updateOptions(selectDesktop, oldDesktop);
  }

  static updateOptions(options, oldOptions) {
    options.forEach(option => {
      const oldOption = oldOptions.find(oldOption => oldOption.dataset.value === option.dataset.value);

      if (oldOption) oldOption.classList = option.classList;
    });
  }

  static getSections() {
    return [{ section: document.getElementById('product-grid').dataset.id }];
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.target.className === 'facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);

      // Hiding the CMS page tiles on a filtered grid is now decided in Liquid,
      // which simply doesn't render them (snippets/product-grid.liquid). The
      // code that used to live here toggled a `grid-item-inactive` class, but
      // tested two NodeLists for truthiness — and a NodeList is always truthy,
      // so it hid the tiles on the first filter click and never brought them
      // back, even once every filter was cleared.
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');

            noJsElements.forEach((el) => el.remove());

            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    FacetFiltersForm.toggleActiveFacets();

    const href = event.currentTarget.href;
    let url = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);

    const band = event.currentTarget.dataset.sizeBand;
    if (band) url = FacetFiltersForm.withoutSizeBand(url, band);

    FacetFiltersForm.renderPage(url);

    
  }

  // A size band's chip stands for every size in the band, but its href (Shopify's
  // url_to_remove) only drops the first. Drop the rest too, read from the band's hidden
  // inputs in the filter panel (snippets/product-filters.liquid).
  static withoutSizeBand(searchParams, band) {
    const members = new Set();

    document.querySelectorAll('input[data-size-band-member]').forEach((input) => {
      if (input.dataset.sizeBandMember === band) members.add(`${input.name}=${input.value}`);
    });

    const kept = new URLSearchParams();

    new URLSearchParams(searchParams).forEach((value, key) => {
      if (!members.has(`${key}=${value}`)) kept.append(key, value);
    });

    return kept.toString();
  }

  addToggleGridListener() {
    const iconSquare = document.querySelector(".filters__icons .icon--square");
    const iconGrid = document.querySelector(".filters__icons .icon--grid");

    if (!iconGrid || !iconSquare) return;

    iconGrid.addEventListener("click", () => FacetFiltersForm.setGridView(false));
    iconSquare.addEventListener("click", () => FacetFiltersForm.setGridView(true));

    FacetFiltersForm.applyGridView();
  }

  addFakeSelectListener() {
    const selects = [".filters__select", ".pagination__select"];

    selects.forEach(input => {
      const select = document.querySelector(input);

      if (!select) return;

      const dropdown = select.querySelector(".select__dropdown");
      const options = select.querySelectorAll("li");
      const label = select.querySelector(".filters__label") || select.querySelector(".pagination__label");

      const filtersDropdown = select.querySelector(".filters__drawer");
      const filterLabel = select.querySelector(".filters__button.js-drawer-trigger") || select.querySelector(".pagination__label");

      if (label) label.addEventListener("click", () => dropdown.classList.toggle("select__dropdown--active"));

      if (filterLabel) filterLabel.addEventListener("click", () => filtersDropdown.classList.toggle("filters__drawer--active"));

      options.forEach(option => option.addEventListener("click", event => {
        this.updateSelect(event);

        if (dropdown) dropdown.classList.remove("select__dropdown--active");
      }));

      if (dropdown) {
        const isDesktop = window.matchMedia("(min-width: 750px)").matches;
        if (!isDesktop) {
          // Unscoped lookup, so it finds whatever close button happens to be on the page.
          // Sort moved inside the filter panel and no longer renders one, and without the
          // guard the throw here took out the pagination dropdown's listeners below.
          const close = document.querySelector(".js-sort-close");
          if (close) close.addEventListener("click", () => dropdown.classList.toggle("select__dropdown--active"));
        }

        window.addEventListener("click", event => {
          if (!select.contains(event.target) && dropdown?.classList.contains("select__dropdown--active")) {
            dropdown.classList.remove("select__dropdown--active");
          }
        });
      }
    });
  }

  updateSelect(event) {
    const select = this.querySelector("select");
    const options = Array.from(select.querySelectorAll("select option"));
    const selected = event.target.dataset.value;
    const selectedOption = options.find(option => option.value === selected);

    if (selectedOption) select.value = selectedOption.value;

    this.onSubmitHandler(event);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.setListeners();

customElements.define('facet-filters-form', FacetFiltersForm);

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    const facetLink = this.querySelector('a');

    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();

      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();

    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
